import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../common/data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DelegateService {

  constructor(private _router: Router, private http: HttpClient,private _data: DataService) { }

  AddDelegate = (data: any): any => {
    return this._data.PostData('Delegate/SaveDelegate', data);
  }

  GetAllDelegationMasterList = (data: any): any => {
    return this._data.PostData('Delegate/GetAllDelegateList', data);
  }

  GetDelegateByID = (ID: string): any => {    
    return this._data.PostData('Delegate/GetDelegateByID', {Param1:ID});
  }

  GetDelegationList() {
      return this._data.PostData('Delegate/GetAllActiveDelegateList', null);
  }

  DeleteDelegate= (delegate: any[]): any =>{  
    return this._data.PostData('Delegate/DeleteDelegateByID', delegate);  
} 
ExportData = (data: any): any => {
  return this._data.DownloadFileWithPost('Delegate/ExportToExcel', data);
} 
}


